import { render, staticRenderFns } from "./AccountSupport.vue?vue&type=template&id=679a7020&scoped=true"
import script from "./AccountSupport.vue?vue&type=script&lang=js"
export * from "./AccountSupport.vue?vue&type=script&lang=js"
import style0 from "./AccountSupport.vue?vue&type=style&index=0&id=679a7020&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "679a7020",
  null
  
)

export default component.exports